import React from 'react'
import PropTypes from 'prop-types'
import { Divider, Paper, Skeleton, Stack, Typography } from '@mui/material'
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined'

const MetricRow = ({ label, value, percentage }) => (
  <Stack direction='row' justifyContent='space-between' alignItems='baseline'>
    <Typography variant='body2' color='text.secondary'>
      {label}
    </Typography>
    <Typography variant='body1' fontWeight={600}>
      {value}
      {percentage != null && (
        <Typography
          component='span'
          variant='body2'
          color='text.secondary'
          sx={{ ml: 0.75 }}
        >
          ({percentage}%)
        </Typography>
      )}
    </Typography>
  </Stack>
)

export const DrivePerformanceCard = ({ performance, loading }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2, md: 3 },
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        height: '100%',
      }}
    >
      <Stack direction='row' spacing={1} alignItems='center' sx={{ mb: 2 }}>
        <EmojiEventsOutlinedIcon sx={{ fontSize: 20 }} />
        <Typography variant='h6' fontWeight={700}>
          Drive Performance
        </Typography>
      </Stack>

      {loading ? (
        <Stack spacing={1.5}>
          {Array.from({ length: 8 }).map((_, index) => (
            <Skeleton key={index} variant='text' height={22} />
          ))}
        </Stack>
      ) : (
        <Stack divider={<Divider />} spacing={1.5}>
          <MetricRow
            label='Goal (Units)'
            value={performance?.goal_units ?? 0}
          />
          <MetricRow
            label='Units Collected'
            value={performance?.units_collected ?? 0}
          />
          <MetricRow
            label='Collection Rate'
            value={`${performance?.collection_rate ?? 0}%`}
          />
          <MetricRow
            label='Total Donors'
            value={performance?.total_donors ?? 0}
          />
          <MetricRow
            label='First Time Donors'
            value={performance?.first_time_donors ?? 0}
            percentage={performance?.first_time_donors_percentage}
          />
          <MetricRow
            label='Appointments Kept'
            value={performance?.appointments_kept ?? 0}
            percentage={performance?.appointments_kept_percentage}
          />
          <MetricRow
            label='Donors Deferred'
            value={performance?.donors_deferred ?? 0}
          />
          <MetricRow
            label='No Shows'
            value={performance?.no_shows ?? 0}
            percentage={performance?.no_shows_percentage}
          />
        </Stack>
      )}
    </Paper>
  )
}

DrivePerformanceCard.propTypes = {
  performance: PropTypes.object,
  loading: PropTypes.bool,
}
